import { ReactElement } from 'react';
import './Content.scss';

interface ContentProps {
    children: ReactElement;
    isFullHeight?: boolean;
}

export default function Content({ children, isFullHeight }: Readonly<ContentProps>) {
    return (
        <div className={`content-ct ${isFullHeight ? 'full-height' : 'auto-height'}`}>
            {children}
        </div>
    )
}